import {Injectable} from "@angular/core";
import { ConnectionBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {environment} from "../environments/environment";
import { AdalService } from "./services/adal.service";

@Injectable()
export class InterceptedHttp extends Http {
    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, private adalService : AdalService) {
        super(backend, defaultOptions);
        
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, options);
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        url = this.updateUrl(url);
        //console.log(options);
        
        return super.get(url, this.getRequestOptionArgs(options));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        url = this.updateUrl(url);
        console.log(url);
        return super.post(url, body, this.getRequestOptionArgs(options));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        url = this.updateUrl(url);
        return super.put(url, body, this.getRequestOptionArgs(options));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        url = this.updateUrl(url);
        return super.delete(url, this.getRequestOptionArgs(options));
    }

    private updateUrl(req: string) {
        //console.log(req);
        if(req.startsWith("http"))
        {
            req;
        }
        else
        {
            return  environment.baseUrl + req;
        }
        
    }

    private getRequestOptionArgs(options?: RequestOptionsArgs) : RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }
        options.headers.append('Content-Type', 'application/json');
        options.headers.append('X-Empyrean', 'Custome header value');

        // let token = sessionStorage.getItem('accessToken');
        // if(token){
        //     options.headers.append('Authorization', 'Bearer ' + token);
        // }

        
        if(this.adalService.isAuthenticated){
            options.headers.append('Authorization', 'Bearer ' + this.adalService.accessToken);
        }

        //console.log(options);

        return options;
    }
}


// WEBPACK FOOTER //
// ./src/app/intercepted-http.ts